<template>
<div :class="[
            'directory',
            isKBDirExpand ? 'directory_expand' : 'directory_no_expand'
        ]" id="kb_dir_list_container">
        <!-- 同程管家品牌 -->
        <DirBrand v-if="!isLoadingTreeNodes"></DirBrand>
        <!-- 目录头部 -->
        <DirHead :isLoadingTreeNodes="isLoadingTreeNodes" @changeExpand="changeExpand"></DirHead>
        <!-- 目录搜索 -->
        <DirSearch @gotoSearch="gotoSearch" @gotoAISearch="gotoAISearch" v-if="!isLoadingTreeNodes && isMember"></DirSearch>

        <div v-if="!isLoadingTreeNodes" :class="['kb_content', isOnline ? '' : 'kb_content_no_network']" @click="noNetworkClick">
            <!-- 新建头部 -->
            <DirNewHead :isLoadingTreeNodes="isLoadingTreeNodes" @addFirstLevelDir="addFirstLevelDir"></DirNewHead>
            <!--目录-->
            <div class="kb_dir_list" v-if="!isLoadingTreeNodes">
                <a-tree v-if="!isShowEmptyDir" blockNode :data="treeNodes" :load-more="loadMore" :size="'medium'" :selected-keys="selectedKeys" v-model:expanded-keys="expandedKeys" @select="onSelectNode" @expand="onExpand" @expandEnd="onExpandEnd" draggable @drop="onDrop" @drag="onDrag" @drag-start="onDragStart" @drag-end="onDragEnd" @drag-over="onDragOver" @drag-leave="onDragLeave" ref="treeRef" :virtualListProps="({
                        height: virtualListHeight, // 可视区域高度              ,
                        threshold: 50, // 虚拟滚动的元素数量阈值，当数量小于阈值时不开启虚拟滚动
                        fixedSize: true, // 元素高度是否固定
                        estimatedSize: 37,
                        buffer: 20 // 视口边界外提前挂载的元素数量
                    })">
                    <template #extra="nodeData">
                        <DirTreeNodeMenu class="dirTreeNodeMenu" :isRenaming="isRenaming" :nodeData="nodeData" @handleFile="handleFile" @createFile="addFile"></DirTreeNodeMenu>
                    </template>
                </a-tree>
                <div v-else class="kb_dir_empty">
                    <span>{{$t("暂无内容")}}</span>
                    <br/>
                    <span v-if="isCanAddFirstLevel">{{$t("点击目录中「+」新建")}}</span>
                </div>
            </div>
            <!-- 目录文案超长tip-->
            <DirNodeTitleTip></DirNodeTitleTip>
            <!-- 底部设置 -->
            <DirBottom v-if="isMember" @gotoRecycle="onGotoRecycle" @gotoSetting="onGotoSetting"></DirBottom>
        </div>
        <div v-else>
            <!-- 骨架屏 -->
            <DirSkeleton></DirSkeleton>
        </div>
        <!-- 申请权限 -->
        <DirApplyAuth :myAuth="myAuth" :creator="creator" :authFileId="authFileId"></DirApplyAuth>
        <!-- 目录拖拽宽度 -->
        <DirScale></DirScale>
    </div>
    <DirTemplateLibNew ref="dirTemplateLibNew" @requestKBCreateFile="requestKBCreateFile"></DirTemplateLibNew>
    <UploadFile ref="uploadFile" @uploadComplete="uploadComplete"></UploadFile>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import { mapActions, mapState, mapGetters } from 'vuex';

import DirBrand from './components/DirBrand.vue';
import DirHead from './components/DirHead.vue';
import DirSearch from './components/DirSearch.vue';
import DirNewHead from './components/DirNewHead.vue';
import DirBottom from './components/DirBottom.vue';
import DirSkeleton from './components/DirSkeleton.vue';
import DirScale from './components/DirScale.vue';
import DirTreeNodeMenu from './components/DirTreeNodeMenu.vue';
import DirNodeTitleTip from './components/DirNodeTitleTip.vue';
import DirApplyAuth from './components/DirApplyAuth.vue';
import UploadFile from "./upload/UploadFile.vue";

import { scrollTo } from './util.js';
import {
getNodeInfo,
deleteNodeInfo,
TreeNodes,
transFileInfoToTreeNode,
getNearstOrParentTreeNode,
nodeTreesContainSubTreeNodes,
getAllNodeFileIds,
updateNodeAuth,
traverse,
WikiFileInfo } from
'../../store/kbTreeNodeModule';
import { trimmedString } from './js/DirTool.js';
import {
getKBSubTreeNode,
kbCreateFile,
kbDeleteFile,
kbRenameFile,
kbDirMove,
kbSameDirSort,
getAllFileAuth,
kbStarFile,
getKBTreeNode } from
'../../core/api/file';
import { Modal } from '@toca/arco-design-web-vue';
import { store } from '../../store/store';
import {
loopTree,
deleteDragThumbEL,
addDragThumbEL } from
'./js/DirDragAndSort.js';
import { getBrowser } from '../../utils/browser';

import ApplyAuthView from '../share/ApplyAuthView.vue';
import UrlRouterUtil from '@/utils/UrlRouterUtil';
import DirTemplateLibNew from './components/DirTemplateLibNew.vue';

// hover提示
import { addHoverStyle } from './js/DirNodeHoverTool.js';
import { nextTick } from 'vue';
import { debounce } from '../../utils/lodash';
import { h } from 'vue';

const globalExpandedKeys = [];
const getExpandParentNodeKeys = function findExpandParentNodeKeys(
arr: TreeNodes[],
fileId: string)
: string[] {
  for (let i = 0; i < arr.length; i++) {
    let treeNodes = arr[i];
    if (
    treeNodes &&
    treeNodes.children &&
    treeNodes.children.length > 0 &&
    treeNodes.fileId != fileId &&
    nodeTreesContainSubTreeNodes(treeNodes, fileId))
    {
      globalExpandedKeys.push(treeNodes.key);
      let result = findExpandParentNodeKeys(treeNodes.children, fileId);
      globalExpandedKeys.concat(result);
    }
  }

  return globalExpandedKeys;
};

export default {
  name: 'directory',
  props: ['docId'],
  emits: [
  'gotoSearch',
  'gotoAISearch',
  'foldKBDir',
  'starFile',
  'unstarFile',
  'getMoreAuth',
  'moveFile',
  'createCopy',
  'updateBreadcrumb'],

  components: {
    DirTreeNodeMenu,
    DirHead,
    DirNewHead,
    DirSearch,
    ApplyAuthView,
    DirBrand,
    DirBottom,
    DirSkeleton,
    DirScale,
    DirNodeTitleTip,
    DirApplyAuth,
    DirTemplateLibNew,
    UploadFile },

  data() {
    return {
      isRenaming: false,
      renamingFileId: '',
      expand: true,
      selectedKeys: Array<string>(),
      expandedKeys: Array<string>(),
      isTreeNodeDragging: false,
      dragInterval: null,
      isOnline: true,
      myAuth: String,
      creator: String,
      authFileId: String,
      virtualDomScrollTimer: null,
      virtualDomScrollStyleObserver: null,
      debounceKBStar: null };

  },
  computed: {
    ...mapState({
      wikiSpaceInfo: (state) => state.kbTreeNodeModule.wikiSpaceInfo,
      treeNodes: (state) => state.kbTreeNodeModule.treeNodes,
      memberIdentity: (state) => state.kbTreeNodeModule.memberIdentity,
      treeType: (state) => state.kbTreeNodeModule.treeType,
      curSelectedTreeNodes: (state) =>
      state.kbTreeNodeModule.curSelectedTreeNodes,
      isKBDirExpand: (state) => state.kbTreeNodeModule.isKBDirExpand,
      fileId: (state) => state.kbTreeNodeModule.fileId,
      space: (state) => state.kbTreeNodeModule.space,
      memberAcl: (state) => state.kbTreeNodeModule.memberAcl,
      fileInfo: (state) => state.kbTreeNodeModule.fileInfo,
      dirOperateTimes: (state: any) =>
      state.kbTreeNodeModule.dirOperateTimes }),

    createFileDefaultName() {
      return store.state.kbModule.wikiSpaceInfo?.wikiSpaceSettings?.defaultFileName ?? '';
    },
    fileNamingType() {
      return store.state.kbModule.wikiSpaceInfo?.wikiSpaceSettings?.fileNamingType ?? 'ORIGINAL_NAME';
    },
    virtualListHeight() {
      return '100%';
      // 品牌（28） + 头部（50） + 搜索（49）+ 目录新建头部（37） + 底部（42) + 目录树下方（30）
      return (
        document.body.getBoundingClientRect().height -
        28 -
        50 -
        49 -
        37 - (
        this.isMember ? 42 : 0) -
        30);

    },
    ...mapGetters({
      isAdmin: 'kbTreeNodeModule/isAdmin',
      isMember: 'kbTreeNodeModule/isMember',
      allFileIds: 'kbTreeNodeModule/allFileIds' }),

    isLoadingTreeNodes() {
      return store.state.kbTreeNodeModule.isLoadingTreeNodes;
    },
    treeWidth() {
      let width = localStorage.getItem('kb_directory_width');
      if (width === null || width === undefined) {
        localStorage.setItem('kb_directory_width', '210px');
        return '210px';
      }
      return width;
    },
    isShowEmptyDir() {
      if (this.isMember && this.treeNodes && this.treeNodes.length == 0) {
        // 知识库成员并且没有文件
        return true;
      }
      return false;
    } },

  watch: {
    treeNodes: {
      handler(newVal, oldVal) {
        this.setCurSelectedTreeNodes(
        getNodeInfo(this.treeNodes, this.docId));

        this.selectedKeys = [this.docId];
        this.addArcoNodeHoverStyle();
      },
      deep: true },

    isLoadingTreeNodes: {
      handler(newVal, oldVal) {
        if (newVal === false) {
          this.setCurSelectedTreeNodes(
          getNodeInfo(this.treeNodes, this.docId));

          this.selectedKeys = [this.docId];
          //展开所有父节点
          this.expandedKeys = getExpandParentNodeKeys(
          this.treeNodes,
          this.docId);

          this.expandedKeys = this.expandedKeys.filter(
          (item, index) => item !== this.docId);


          this.handleTreeAfterShow();
        }
      } },

    curSelectedTreeNodes: {
      handler(newVal, oldVal) {
        // this.setDirOperateTimes(this.dirOperateTimes + 1);
        this.addArcoNodeHoverStyle();
      },
      deep: true } },


  methods: {
    ...mapActions({
      setIsNewDoc: 'kbEditModule/setIsNewDoc',
      setDocView: 'kbModule/setDocView',
      setCurSelectedTreeNodes: 'kbTreeNodeModule/setCurSelectedTreeNodes',
      setWikiNewFileInfo: 'kbTreeNodeModule/setWikiNewFileInfo',
      transTreeNodes: 'kbTreeNodeModule/transTreeNodes',
      setDocType: 'kbModule/setDocType',
      setDocId: 'kbModule/setDocId',
      updateDocTitle: 'hocuspocusModule/updateDocTitle',
      setDirApplyDialog: 'kbTreeNodeModule/setDirApplyDialog',
      setIsNewCreate: 'kbEditModule/setIsNewCreate',
      setEditDocType: 'kbEditModule/setEditDocType',
      setShowTemplate: 'kbTreeNodeModule/setShowTemplate',
      setDirOperateTimes: 'kbTreeNodeModule/setDirOperateTimes' }),

    scrollToSelectedNode(key?: string) {
      nextTick(() => {
        const fileIds = this.allFileIds;
        if (
        fileIds &&
        fileIds.length > 0 &&
        fileIds.includes(this.docId))
        {
          const index = fileIds.indexOf(key ?? this.docId);
          let dirListEL = document.querySelector(
          '.arco-virtual-list');

          if (index > -1 && dirListEL) {
            const offset = index * 37;
            dirListEL.scrollTop = offset;
          }
        }
      });
    },
    handleTreeAfterShow() {
      setTimeout(() => {
        this.scrollToSelectedNode();
        // 监听目录树的滚动
        this.addVirtualDomScrollEventListener();

        //修复其他元素拖动到最后一个时 目录抖动问题
        let arcoTreeEL = document.querySelector('.arco-tree');
        if (arcoTreeEL) {
          let newBtmDiv = document.createElement('div');
          newBtmDiv.style.height = '30px';
          newBtmDiv.style.backgroundColor = 'transparent';
          arcoTreeEL.appendChild(newBtmDiv);
        }
        this.addArcoNodeHoverStyle();
      }, 1000);
    },
    addVirtualDomScrollEventListener() {
      const virtualDom = document.querySelector('.arco-virtual-list');
      if (virtualDom) {
        virtualDom.addEventListener('scroll', () => {
          if (this.virtualDomScrollTimer) {
            clearTimeout(this.virtualDomScrollTimer);
          }
          this.virtualDomScrollTimer = setTimeout(() => {
            this.addArcoNodeHoverStyle();
          }, 200);
        });
      }
    },
    removeVirtualDomScrollStyleObserver() {
      if (this.virtualDomScrollStyleObserver) {
        this.virtualDomScrollStyleObserver.disconnect();
      }
    },
    changeExpand() {
      if (
      this.curSelectedTreeNodes.contentType.toLowerCase() !=
      'document')
      {
        this.$emit('foldKBDir', this.isKBDirExpand);
      }
    },
    onGotoSetting() {
      this.setDocView('setting');
    },
    onGotoRecycle() {
      this.setDocView('trash');
    },
    loadMore(nodeData) {
      if (nodeData.hasChild && nodeData.children.length == 0) {
        //如果有子节点，但是没有请求子节点的话，需要先请求子节点
        return new Promise<void>((resolve) => {
          this.requestKBSubTreeNodeInfo(nodeData, true).then(() => {
            resolve();
          });
        });
      } else {
        return new Promise<void>((resolve) => {
          resolve();
        });
      }
    },
    clickDoc(id, type) {
      this.setDocType('LOADING');
      this.setIsNewDoc(false);
      setTimeout(() => {
        this.setDocView('home');
        this.setDocId(id);
        this.setDocType(type);
      }, 0);
    },
    addFirstLevelDir(docType) {
      // 新建一级目录
      this.addFile(docType, this.wikiSpaceInfo.homePage, true);
    },
    async addFile(docType, nodeData, isFirstLevel = false) {
      // 新建子目录
      if (docType === 'UPLOAD') {
        if (isFirstLevel) {
          this.$refs.uploadFile?.showUploadDialog(this.wikiSpaceInfo.homePage, isFirstLevel);
        } else {
          this.$refs.uploadFile?.showUploadDialog(nodeData.fileId, isFirstLevel);
        }
      } else {
        this.setShowTemplate(true);
        let that = this;
        this.$nextTick(() => {
          that.$refs.dirTemplateLibNew?.showTemplateDialog(
          docType,
          nodeData,
          isFirstLevel);

        });
      }
    },
    handleFile(action, nodeData, treeNodeTextEL) {
      if (action == 'opentab') {
        const origin = window.location.origin;
        if (origin.includes('toca') || origin.includes('wiki')) {
          UrlRouterUtil.openUrl(
          origin + `/wiki?fid=${nodeData.key}`,
          '_blank');

        } else {
          UrlRouterUtil.openUrl(
          origin + `?fid=${nodeData.key}`,
          '_blank');

        }
      } else if (action == 'rename') {
        let oldText = treeNodeTextEL.innerText;
        var titleEL = treeNodeTextEL.parentElement;

        this.isRenaming = true;
        this.renamingFileId = nodeData.key;

        var inputEL = document.createElement('input');
        inputEL.style.width = '100%';
        inputEL.value = nodeData.title;
        inputEL.maxLength = 100; //最多100字
        inputEL.onclick = (event) => {
          console.log(
          '--------------------selection:',
          inputEL.selectionStart,
          inputEL.selectionEnd);

        };
        inputEL.className = 'tree-node-input-text';
        let that = this;
        inputEL.onkeydown = (e) => {
          if (e.keyCode == 13) {
            var inputEL = titleEL.getElementsByClassName(
            'tree-node-input-text')[
            0];
            inputEL.blur();
          }
        };
        inputEL.onblur = (e) => {
          that.isRenaming = false;
          that.renamingFileId = '';
          var inputEL = titleEL.getElementsByClassName(
          'tree-node-input-text')[
          0];
          if (oldText != inputEL.value) {
            that.requestKBRenameFile(
            nodeData.key,
            inputEL.value,
            nodeData);

          }
          if (titleEL.parentNode && inputEL.parentNode) {
            titleEL.replaceChild(treeNodeTextEL, inputEL);
          }
        };
        if (titleEL.parentNode) {
          titleEL.replaceChild(inputEL, treeNodeTextEL);
          inputEL.focus();
          inputEL.select();
        }
      } else if (action == 'delete') {
        this.wpsDeleteFile(nodeData.key);
      } else if (action === 'star') {
        //取消收藏
        this.debounceKBStar(nodeData, false);
      } else if (action === 'unstar') {
        //收藏
        this.debounceKBStar(nodeData, true);
      } else if (action === 'getauth') {
        this.myAuth = nodeData.auth;
        this.creator = nodeData.owner.userName;
        this.authFileId = nodeData.key;
        this.setDirApplyDialog(true);
      } else if (action === 'move-to') {
        this.$emit('moveFile', nodeData);
      } else if (action === 'create-copy') {
        this.$emit('createCopy', nodeData);
      }
    },
    onSelectNode(newSelectedKeys, data) {
      var fileId = newSelectedKeys[0];
      //兼容： cmd + 点击 打开新的tab
      if (data.e) {
        if (data.e.ctrlKey || data.e.metaKey) {
          const origin = window.location.origin;
          if (origin.includes('toca') || origin.includes('wiki')) {
            UrlRouterUtil.openUrl(
            origin + `/wiki?fid=${fileId}`,
            '_blank');

          } else {
            UrlRouterUtil.openUrl(
            origin + `?fid=${fileId}`,
            '_blank');

          }
          return;
        }
      }

      //添加防止重复点击逻辑，重复点击不处理
      if (this.selectedKeys.includes(fileId)) {
        return;
      }

      if (this.isRenaming && fileId == this.renamingFileId) {
        //当前node正在被改名字
        return;
      }
      this.selectedKeys = [fileId];
      let treeNodes = getNodeInfo(this.treeNodes, fileId);
      this.setCurSelectedTreeNodes(treeNodes);
      this.clickDoc(
      this.curSelectedTreeNodes.fileId,
      this.curSelectedTreeNodes.contentType);

      console.log(
      '选中节点信息',
      this.curSelectedTreeNodes,
      this.curSelectedTreeNodes.key);


      if (
      data &&
      data.node &&
      data.node.children.length > 0 &&
      !this.expandedKeys.includes(data.node.key))
      {
        //有子节点，并且未展开
        this.expandedKeys.push(data.node.key);
      }
      if (
      data &&
      data.node &&
      data.node.hasChild &&
      data.node.children.length === 0)
      {
        //有子节点，但是没有请求
        this.requestKBSubTreeNodeInfo(data.node, true);
      }
      this.addArcoNodeHoverStyle();

      if (getBrowser().isInTocaApp === true) {
        //pc端内切换目录
        const origin = window.location.origin;
        UrlRouterUtil.openUrl(
        origin + `/wiki?fid=${fileId}&isClickDir=true`,
        '_self');

        return;
      }
    },
    onExpand(newExpandedKeys, nodeData) {
      let key = nodeData.node.key;
      if (this.expandedKeys.includes(key)) {
        let index = this.expandedKeys.indexOf(key);
        this.expandedKeys.splice(index, 1);
      } else {
        this.expandedKeys.push(key);
      }
      this.addArcoNodeHoverStyle();
    },
    onExpandEnd() {
      this.addArcoNodeHoverStyle();
      console.log('-------------------------dirOperateTimes', this.dirOperateTimes);
    },
    selectNode(selectKey) {
      this.$refs.treeRef.scrollIntoView({ key: selectKey });
      let treeNodes = getNodeInfo(this.treeNodes, selectKey);
      if (treeNodes !== null) {
        this.$refs.treeRef.selectNode(selectKey, treeNodes);
      } else {
        const origin = window.location.origin;
        if (origin.includes('toca') || origin.includes('wiki')) {
          UrlRouterUtil.openUrl(
          origin + `/wiki?fid=${selectKey}`,
          '_blank');

        } else {
          UrlRouterUtil.openUrl(
          origin + `?fid=${selectKey}`,
          '_blank');

        }
      }
    },
    async requestKBSubTreeNodeInfo(nodeData, isSelect, isNeedExpand = true) {
      try {
        const res: any = await getKBSubTreeNode(nodeData.fileId);
        const { code, data, message }: any = res.data || {};
        if (code == 200) {
          //子节点信息插入到children
          if (data && data.length > 0) {
            // data.forEach(element => {
            //     nodeData.children.push(element);
            // });
            nodeData.children = [...data];
          }
        }
        //转换数据
        this.transTreeNodes();
        let key = nodeData.node ? nodeData.node.key : nodeData.key;
        if (isNeedExpand === true && !this.expandedKeys.includes(key)) {
          this.expandedKeys.push(key);
        }
        this.addArcoNodeHoverStyle();
        console.log('目录子节点接口请求成功:', data);
      } catch (err) {
        console.log('目录子节点接口请求失败：', err);
      }
    },
    async requestKBCreateFile(
    newFileType: string,
    parentId: string,
    isFirstLevel: Boolean,
    templateFileId: string,
    nodeData?)
    {
      if (isFirstLevel === true) {
        this.$refs.treeRef.scrollIntoView({
          key: this.allFileIds[0] });

      }
      try {
        let res: any = null;
        if (this.fileNamingType === 'CUSTOM' && this.createFileDefaultName && this.createFileDefaultName.length > 0) {
          res = await kbCreateFile('WIKI_FILE', newFileType, parentId, templateFileId, this.createFileDefaultName);
        } else {
          res = await kbCreateFile('WIKI_FILE', newFileType, parentId, templateFileId);
        }
        const { code, data, message }: any = res.data || {};
        if (code == 200) {
          //处理文件类型 和 文件名称
          data.type = newFileType;
          if (data.fileName && data.fileName.length > 0) {
            let strArr = data.fileName.split('.');
            if (strArr.length > 0) {
              data.fileName = strArr[0];
            }
          }
          this.setIsNewCreate(true);
          // 默认选中新建的文件
          this.setWikiNewFileInfo(data);

          //转换数据并添加到父级节点中
          let newTreeNodes = transFileInfoToTreeNode(this.fileInfo);
          if (!isFirstLevel) {
            if (
            nodeData.hasChild &&
            nodeData.children.length == 0)
            {
              //如果有子节点，但是没有请求子节点的话，需要先请求子节点
              await this.requestKBSubTreeNodeInfo(
              nodeData,
              false);

            }
            if (getNodeInfo(this.treeNodes, data.fileId) == null) {
              //如果没有节点才添加
              nodeData.children.splice(0, 0, newTreeNodes);
            }
            nodeData.hasChild = true;
            nodeData.isLeaf = false;
            //默认展开父节点
            this.expandedKeys.push(parentId);

            //父级页面hasChild改为true
            let treeNodes = getNodeInfo(
            this.treeNodes,
            nodeData.fileId);

            if (treeNodes) {
              treeNodes.hasChild = true;
              treeNodes.isLeaf = false;
            }
          } else {
            if (getNodeInfo(this.treeNodes, data.fileId) == null) {
              //如果没有节点才添加
              //判断第一个节点的sortNo是不是0 （0： 首页   其他： 非首页）
              let firstNodeIsHomePage = false;
              if (this.treeNodes && this.treeNodes.length > 0) {
                let firstNode = this.treeNodes[0];
                if (firstNode && firstNode.sortNo == 0) {
                  firstNodeIsHomePage = true;
                }
              }
              if (firstNodeIsHomePage) {
                this.treeNodes.splice(1, 0, newTreeNodes);
              } else {
                this.treeNodes.splice(0, 0, newTreeNodes);
              }
            }
          }

          //设置新建的文件光标
          setTimeout(() => {
            //切换编辑器
            this.setCurSelectedTreeNodes(newTreeNodes);
            this.clickDoc(
            this.curSelectedTreeNodes.fileId,
            this.curSelectedTreeNodes.contentType);

            //延迟选中，等数据添加成功，选中
            this.selectedKeys = [this.fileInfo.fileId];
            this.setIsNewDoc(true);
            this.addArcoNodeHoverStyle();
            this.$message.info(intl.$t("文件创建成功"));
            if (getBrowser().isInTocaApp === true) {
              //pc端内切换目录
              const origin = window.location.origin;
              UrlRouterUtil.openUrl(
              origin +
              `/wiki?fid=${this.curSelectedTreeNodes.fileId}`,
              '_self');

              return;
            }
          }, 0);
        }
      } catch (err) {
        this.$message.error(intl.$t("文件创建失败"));
      }
    },
    async requestKBStarFile(nodeData, isStar) {
      try {
        const fileId = nodeData.key;
        const res: any = await kbStarFile(fileId, isStar);
        const { code, data, message }: any = res.data || {};
        if (code == 200) {
          if (isStar) {
            this.$message.success(intl.$t("已添加到“收藏”"));
            nodeData.star = true;
            this.$emit('starFile');
          } else {
            this.$message.success(intl.$t("已从“收藏”中移除"));
            nodeData.star = false;
            this.$emit('unstarFile');
          }
        }
      } catch (err) {
        if (isStar) {
          this.$message.error(intl.$t("收藏失败"));
        } else {
          this.$message.error(intl.$t("取消收藏失败"));
        }
      }
    },
    wpsDeleteFile(fileId: any) {
      let that = this;
      Modal.warning({
        title: intl.$t("确定要删除吗?"),
        content: () => {
          return h('div', { style: { fontSize: '14px', color: '#121317', lineHeight: '28px' } }, [intl.$t("将删除此页面和它包含的所有子页面，删除后可在左下角"),

          h('span', {
            style: {
              alignItems: 'center',
              background: '#E3E8FF',
              borderRadius: '8px',
              border: '1px solid #E3E8FF',
              margin: '0 5px',
              padding: '6px 8px 5px 8px',
              color: '#4050FF',
              fontSize: '14px',
              height: '22px' } },

          [
          h('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg',
            style: { marginTop: '-4px', marginRight: '2px', verticalAlign: 'middle' } },

          [
          h('g', {
            fill: '#4050FF',
            'fill-rule': 'nonzero' },
          [
          h('path', {
            d: 'M5.625,2.875 L5.5,2.875 C5.56875,2.875 5.625,2.81875 5.625,2.75 L5.625,2.875 L10.375,2.875 L10.375,2.75 C10.375,2.81875 10.43125,2.875 10.5,2.875 L10.375,2.875 L10.375,4 L11.5,4 L11.5,2.75 C11.5,2.1984375 11.0515625,1.75 10.5,1.75 L5.5,1.75 C4.9484375,1.75 4.5,2.1984375 4.5,2.75 L4.5,4 L5.625,4 L5.625,2.875 Z' }),

          h('path', {
            d: 'M13.5,4 L2.5,4 C2.2234375,4 2,4.2234375 2,4.5 L2,5 C2,5.06875 2.05625,5.125 2.125,5.125 L3.06875,5.125 L3.4546875,13.296875 C3.4796875,13.8296875 3.9203125,14.25 4.453125,14.25 L11.546875,14.25 C12.08125,14.25 12.5203125,13.83125 12.5453125,13.296875 L12.93125,5.125 L13.875,5.125 C13.94375,5.125 14,5.06875 14,5 L14,4.5 C14,4.2234375 13.7765625,4 13.5,4 Z M11.4265625,13.125 L4.5734375,13.125 L4.1953125,5.125 L11.8046875,5.125 L11.4265625,13.125 Z' })])]), intl.$t("回收站")]), intl.$t("处找回。")]);








        },
        modalClass: 'delete_dialog',
        bodyClass: 'delete_dialog_body',
        titleAlign: 'start',
        closable: false,
        hideCancel: false,
        okText: intl.$t("确定"),
        cancelText: intl.$t("取消"),
        onOk(e) {
          let treeNode = getNodeInfo(that.treeNodes, fileId);
          that.requestKBDeleteFile(treeNode);
        } });

    },
    async requestKBDeleteFile(nodeData) {
      try {
        const fileId = nodeData.key;
        const res: any = await kbDeleteFile([fileId]);
        const { code, data, message }: any = res.data || {};
        if (code == 200) {
          this.handleDeleteFile(nodeData.key, true, nodeData);
          this.addArcoNodeHoverStyle();
        } else {
          this.$message.error(intl.$t("删除失败"));
        }
      } catch (err) {
        // this.$message.error('删除失败');
        console.log('------------------删除失败：', err);
      }
    },
    handleDeleteFile(fileId, isShowTip, nodeData?) {
      //选中最近的文件 同级下边 》 同级上边 》 父文件
      if (nodeData) {
        //目录树中删除
        if (
        isShowTip &&
        nodeData.key != this.curSelectedTreeNodes.key)
        {
          this.$message.info(intl.$t("删除成功"));
        }
        if (
        fileId == this.curSelectedTreeNodes.key ||
        nodeTreesContainSubTreeNodes(
        nodeData,
        this.curSelectedTreeNodes.key))

        {
          //如果删除的是 当前选中的文档 或者子级文档包含选中的文档，则查找最近的文档或者父级文档
          let treeNodes = getNearstOrParentTreeNode(
          this.treeNodes,
          nodeData.key);

          if (treeNodes) {
            setTimeout(() => {
              this.setCurSelectedTreeNodes(treeNodes);
              this.clickDoc(
              this.curSelectedTreeNodes.fileId,
              this.curSelectedTreeNodes.contentType);

              this.selectedKeys = [treeNodes.fileId];
            }, 0);
          }
        }
      } else {
        //如果删除的是 当前选中的文档 或者子级文档包含选中的文档，则查找最近的文档或者父级文档
        let treeNodes = getNearstOrParentTreeNode(
        this.treeNodes,
        fileId);

        if (treeNodes) {
          setTimeout(() => {
            this.setCurSelectedTreeNodes(treeNodes);
            this.clickDoc(
            this.curSelectedTreeNodes.fileId,
            this.curSelectedTreeNodes.contentType);

            this.selectedKeys = [treeNodes.fileId];
          }, 0);
        }
      }

      //删除节点
      if (fileId && fileId.length > 0) {
        deleteNodeInfo(this.treeNodes, fileId);
      }

      if (this.treeNodes && this.treeNodes.length == 0) {
        this.setDocView('emptyfile');
      }
    },
    async requestKBRenameFile(fileId: string, fileName: string, nodeData) {
      try {
        let treeNode = getNodeInfo(this.treeNodes, fileId);
        let trimFileName = trimmedString(fileName);
        if (trimFileName.length > 0) {
          let newFileName = trimFileName;
          if (treeNode.contentType == 'EXCEL') {
            newFileName = newFileName + '.xlsx';
          } else if (treeNode.contentType == 'PPT') {
            newFileName = newFileName + '.ppt';
          }
          const res: any = await kbRenameFile(fileId, newFileName);
          const { code, data, message }: any = res.data || {};
          if (code == 200) {
            treeNode.fileName = trimFileName;
            treeNode.fileNamePrefix = trimFileName;
            nodeData.title = trimFileName;
            if (nodeData.key != this.curSelectedTreeNodes.key) {
            }
            if (treeNode.key == this.curSelectedTreeNodes.key) {
              this.updateDocTitle(trimFileName);
            }
            // this.setDirOperateTimes(this.dirOperateTimes + 1);
            this.addArcoNodeHoverStyle();
          }
        }
      } catch (err) {
      }
    },
    async requestDirMove(dragNode, dropNode, dropPosition) {
      try {
        //-------------------------- 拼装参数
        let fileId = dragNode.key;
        let targetId = dropNode.parentId; //默认去drop节点的父节点的id
        if (dropPosition === 0) {
          // drop节点是父节点
          targetId = dropNode.key;
        }
        let position = 0;
        loopTree(this.treeNodes, dropNode.key, (_, index, arr) => {
          position = dropPosition < 0 ? index : index + 1;
        });
        let sortNo = position + 1 + '';

        //-----------------------------------------如果该节点有子节点，但是没有请求子节点的话，需要先请求子节点
        if (dropPosition === 0) {
          if (dropNode.hasChild && dropNode.children.length == 0) {
            //如果有子节点，但是没有请求子节点的话，需要先请求子节点
            await this.requestKBSubTreeNodeInfo(dropNode, false);
          }
          //默认展开改节点
          this.expandedKeys.push(dropNode.key);
          //默认插入到第一个位置
          sortNo = 1 + '';
        }
        console.log('-------------------------sortNo', sortNo);
        //-----------------------------------------请求移动接口
        const res: any = await kbDirMove(fileId, targetId, sortNo);
        const { code, data, message }: any = res.data || {};
        if (code == 200) {
          //排序成功
          this.$message.info(intl.$t("移动成功，页面已继承新父页面的权限"));

          //提前记录展开的keys
          let expandedKeys = this.expandedKeys;

          dragNode.sortNo = sortNo; //更新新的序号

          //------------------------------------------------处理缓存数据，删除原节点，添加到新节点下
          this.handleLocalTreeSort(dragNode, dropNode, dropPosition);
          //-------------------------------------------------从新刷新一下改父节点下的所有子节点权限（因为权限的变化不能在前端处理，哎~）
          let dragAllFileIds = getAllNodeFileIds(dragNode);
          const resAuth: any = await getAllFileAuth(dragAllFileIds);
          const { code, data, message }: any = resAuth.data || {};
          if (code == 200) {
            updateNodeAuth(dragNode, data);
          }

          //更新面包屑
          this.$emit('updateBreadcrumb');
        } else if (code == 109) {
          this.$message.error(intl.$t("暂无权限移动页面到该位置"));
        }
      } catch (err) {
        this.$message.info(intl.$t("移动失败"));
      }
    },
    async requestSameDirSort(dragNode, dropNode, dropPosition) {
      try {
        let fileId = dragNode.key;
        let position = 0;
        loopTree(this.treeNodes, dropNode.key, (_, index, arr) => {
          position = dropPosition < 0 ? index : index + 1;
        });
        let sortNo = position + 1;
        //判断dragNode和dropNode的顺序
        let dragIndex = 0;
        loopTree(this.treeNodes, dragNode.key, (_, index, arr) => {
          dragIndex = index + 1;
        });
        //从上面往下面拖动，减1
        if (dragIndex < position) {
          sortNo = sortNo - 1;
        }
        let newSortNo = sortNo + '';
        console.log('-------------------------sortNo', newSortNo);
        const res: any = await kbSameDirSort(fileId, newSortNo);
        const { code, data, message }: any = res.data || {};
        if (code == 200) {
          //排序成功
          setTimeout(() => {
            this.$message.info(intl.$t("移动成功"));
          }, 300);
          dragNode.sortNo = newSortNo; //更新新的序号
          this.handleLocalTreeSort(dragNode, dropNode, dropPosition);
        } else if (code == 109) {
          this.$message.info(intl.$t("暂无权限移动页面到该位置"));
        }
      } catch (err) {
        this.$message.info(intl.$t("移动失败"));
      }
    },
    handleLocalTreeSort(dragNode, dropNode, dropPosition) {
      //查找删除被拖拽节点
      loopTree(this.treeNodes, dragNode.key, (_, index, arr) => {
        let dragParentNode = null;
        if (dragNode.parentId !== this.wikiSpaceInfo.homePage) {
          dragParentNode = getNodeInfo(
          this.treeNodes,
          dragNode.parentId);

        }
        arr.splice(index, 1);
        if (dragParentNode != null) {
          dragParentNode.hasChild =
          dragParentNode.children.length > 0 ? true : false;
          dragParentNode.isLeaf =
          dragParentNode.children.length > 0 ? false : true;
        }
      });

      // 把 拖拽节点添加到释放节点中
      if (dropPosition === 0) {
        // 直接拖拽到某个文件夹下面，则在第一个位置添加该拖拽节点
        loopTree(this.treeNodes, dropNode.key, (item) => {
          item.children = item.children || [];
          //修改parentId
          dragNode.parentId = item.key;
          // item.children.push(dragNode)
          item.children.splice(0, 0, dragNode);
          item.hasChild = true;
          item.isLeaf = false;
        });
      } else {
        //从drop位置新增一个节点
        loopTree(this.treeNodes, dropNode.key, (_, index, arr) => {
          //修改parentId
          dragNode.parentId = dropNode.parentId;
          arr.splice(
          dropPosition < 0 ? index : index + 1,
          0,
          dragNode);

        });
      }

      // this.setDirOperateTimes(this.dirOperateTimes + 1);
    },
    onDrag(event) {
      // console.log('---------------------------drag',event.clientX,event.clientY)
      if (this.isTreeNodeDragging) {
        // top
        let topStartX = 0;
        let topEndX = document.
        getElementById('kb_dir_list_container').
        getBoundingClientRect().width;
        let topStartY = 0;
        let topEndY = 54 + 51 + 34 + 50;
        let clientX = event.clientX;
        let clientY = event.clientY;

        //bottom
        let btmStartX = 0;
        let btmEndX = document.
        getElementById('kb_dir_list_container').
        getBoundingClientRect().width;
        let btmStartY = innerHeight - 42 - 50;
        let btmEndY = innerHeight;

        if (
        clientX > topStartX &&
        clientX < topEndX &&
        clientY > topStartY &&
        clientY < topEndY)
        {
          this.isDragInItem = false;
          // 拖到了顶部
          let dirListEL = document.querySelector('.kb_dir_list');
          // if(dirListEL.scrollTop !== 0){
          //   scrollTo(dirListEL,0,300)
          // }
          if (this.dragInterval === null) {
            this.dragInterval = setInterval(() => {
              if (dirListEL.scrollTop !== 0) {
                scrollTo(
                dirListEL,
                dirListEL.scrollTop - 20,
                300);

              }
            }, 100);
          }
        } else if (
        clientX > btmStartX &&
        clientX < btmEndX &&
        clientY > btmStartY &&
        clientY < btmEndY)
        {
          this.isDragInItem = false;
          // 拖到了底部
          let dirListEL = document.querySelector('.kb_dir_list');
          let btm = dirListEL.scrollHeight - dirListEL.clientHeight;
          // scrollTo(dirListEL,btm,300)
          if (this.dragInterval === null) {
            this.dragInterval = setInterval(() => {
              if (dirListEL.scrollTop !== btm) {
                scrollTo(
                dirListEL,
                dirListEL.scrollTop + 20,
                300);

              }
            }, 100);
          }
        } else {
          this.isDragInItem = true;
          clearInterval(this.dragInterval);
          this.dragInterval = null;
        }
      }
    },
    onDrop({ e, dragNode, dropNode, dropPosition }) {
      //如果子节点拖到了父节点里面，不需要排到最后，直接维持原来位置
      if (dragNode.parentId === dropNode.key && dropPosition === 0) {
        return;
      }

      if (dragNode.parentId === dropNode.parentId && dropPosition != 0) {
        //同级排序
        this.requestSameDirSort(dragNode, dropNode, dropPosition);
      } else {
        //跨级移动和排序
        this.requestDirMove(dragNode, dropNode, dropPosition);
      }
    },
    onDragStart(event, dragNode) {
      this.removeArcoNodeHoverStyle();
      store.dispatch(
      'kbTreeNodeTipModule/setIsShowNodeTitleTextTip',
      false);

      //处理拖拽缩略图
      addDragThumbEL(event);
      this.isTreeNodeDragging = true;
    },
    onDragOver(event, dropNode) {},
    onDragLeave(event, dropNode) {},
    onDragEnd(event, dragNode) {
      this.addArcoNodeHoverStyle();
      //删除拖拽缩略图
      deleteDragThumbEL();
      this.isTreeNodeDragging = false;
      clearInterval(this.dragInterval);
      this.dragInterval = null;
    },
    gotoSearch() {
      //搜索
      this.$emit('gotoSearch');
    },
    gotoAISearch() {
      this.$emit('gotoAISearch');
    },
    addArcoNodeHoverStyle() {
      addHoverStyle();
    },
    removeArcoNodeHoverStyle() {
      let arcoNodeELs = document.querySelectorAll('.arco-tree-node');
      arcoNodeELs.forEach((item, index) => {
        if (
        (item as HTMLElement).classList.contains(
        'arco-tree-node-expand'))

        {
          (item as HTMLElement).classList.remove(
          'arco-tree-node-expand');

        }
      });

      let arcoNodeTitleELs = document.querySelectorAll(
      '.arco-tree-node-title');

      arcoNodeTitleELs.forEach((item, index) => {
        if (
        (item as HTMLElement).classList.contains(
        'arco-tree-node-title-expand'))

        {
          (item as HTMLElement).classList.remove(
          'arco-tree-node-title-expand');

        }
      });
    },
    onlineNetwork() {
      this.isOnline = true;
    },
    offlineNetwork() {
      this.isOnline = false;
    },
    noNetworkClick() {
      if (this.isOnline) {
      } else {
        this.$message.error(intl.$t("当前网络处于离线状态，请检查网络环境后重试。"));


      }
    },
    refreshDirExp() {
      this.setCurSelectedTreeNodes(
      getNodeInfo(this.treeNodes, this.docId));

      this.selectedKeys = [this.docId];
      //展开所有父节点
      this.expandedKeys = [
      ...new Set(getExpandParentNodeKeys(this.treeNodes, this.docId))];


      setTimeout(() => {
        let selectDom = document.querySelector(
        `[fileid="${this.docId}"]`);

        if (selectDom) {
          this.$refs.treeRef.scrollIntoView({ key: this.docId });
        }
      }, 0);
    },
    refreshDirExpAndSelect(id: string) {
      setTimeout(() => {
        this.setDocId(id);
        this.setCurSelectedTreeNodes(getNodeInfo(this.treeNodes, id));
        this.selectedKeys = [id];
        //展开所有父节点
        this.expandedKeys = [
        ...new Set(getExpandParentNodeKeys(this.treeNodes, id))];

        this.addArcoNodeHoverStyle();
        let selectDom = document.querySelector(`[fileid="${id}"]`);
        if (selectDom) {
          this.$refs.treeRef.scrollIntoView({ key: id });
        }
      }, 500);
    },
    async uploadComplete(pid, isFirstLevel, task) {
      const fileSuffix = task.name.split('.').pop();
      //获取小数点前面的名称
      const fileName = task.name.substring(0, task.name.lastIndexOf('.'));
      let contentType = 'EXCEL';
      if (fileSuffix.includes('ppt')) {
        contentType = 'PPT';
      }
      const fileInfo: WikiFileInfo = {
        auth: 'ALL',
        createTime: '',
        creator: store.state.userModule.userDetail.memberName, //创建人
        fileId: task.fileId, //文件id
        fileName: fileName, //文件名称
        contentType: contentType, //根据后缀判断类型
        operationTime: '', //操作时间
        parentId: pid, //父级id
        share: false, //是否分享
        size: task.size, //文件大小
        source: 'WIKI', //文件来源
        status: 'COMPLETE', //文件状态
        type: contentType, //文件类型
        versionId: '', //版本id
        creatorInfo: {
          id: store.state.userModule.userDetail.id,
          userId: store.state.userModule.userDetail.userId,
          userName: store.state.userModule.userDetail.memberName,
          userAvatar: store.state.userModule.userDetail.memberAvatar,
          spaceId: store.state.userModule.userDetail.spaceId,
          spaceName: store.state.userModule.userDetail.spaceName || '',
          employeeNo: store.state.userModule.userDetail.employeeNo,
          memberType: 0 }
        //创建人信息
      };
      let newTreeNodes = transFileInfoToTreeNode(fileInfo);
      if (!isFirstLevel) {
        // 获取父级节点信息
        const nodeData = getNodeInfo(this.treeNodes, pid);
        if (
        nodeData.hasChild &&
        nodeData.children.length == 0)
        {
          //如果有子节点，但是没有请求子节点的话，需要先请求子节点
          await this.requestKBSubTreeNodeInfo(
          nodeData,
          false,
          false);

        }
        if (getNodeInfo(this.treeNodes, task.fileId) == null) {
          //如果没有节点才添加
          nodeData.children.splice(0, 0, newTreeNodes);
        }
        nodeData.hasChild = true;
        nodeData.isLeaf = false;
      } else {
        //判断第一个节点的sortNo是不是0 （0： 首页   其他： 非首页）
        let firstNodeIsHomePage = false;
        if (this.treeNodes && this.treeNodes.length > 0) {
          let firstNode = this.treeNodes[0];
          if (firstNode && firstNode.sortNo == 0) {
            firstNodeIsHomePage = true;
          }
        }
        if (firstNodeIsHomePage) {
          this.treeNodes.splice(1, 0, newTreeNodes);
        } else {
          this.treeNodes.splice(0, 0, newTreeNodes);
        }
      }
    } },

  created() {
    if (this.treeNodes) {
      // mainview已经请求目录接口，此处直接使用
      this.setCurSelectedTreeNodes(
      getNodeInfo(this.treeNodes, this.docId));

      this.selectedKeys = [this.docId];
      //展开所有父节点
      this.expandedKeys = getExpandParentNodeKeys(
      this.treeNodes,
      this.docId);

    }
  },
  unmounted() {
    window.removeEventListener('online', this.onlineNetwork);
    window.removeEventListener('offline', this.offlineNetwork);
    this.removeVirtualDomScrollStyleObserver();
  },
  mounted() {
    window.addEventListener('online', this.onlineNetwork);
    window.addEventListener('offline', this.offlineNetwork);
    let dirEL = document.getElementById('kb_dir_list_container');
    if (dirEL) {
      dirEL.style.width = this.treeWidth;
    }
    this.debounceKBStar = debounce(this.requestKBStarFile, 500);
  } };
</script>

<style lang="scss" scoped>
@import './css/dir_variables.scss';
@import './css/dir_scoped.scss';
</style>

<style lang="scss">
@import './css/dir_variables.scss';
@import './css/dir_noscoped.scss';
</style>
